import React, { useState } from 'react'
import { Panel, Placeholder, Message } from 'rsuite'

export default function AgreementAdditional(props) {
  const { Graph } = Placeholder
  const { formSchema } = props

  return (
    <>
      <Panel header={formSchema.title} shaded collapsible defaultExpanded>
        {formSchema ? (
          <div>
            {
              formSchema.content && (
                // (formSchema.status?.statusValue === 'อนุมัติ' ? (
                //   <>
                //     <p style={{ color: '#1621e3' }}>{`${preContentLabel}`}</p>

                //     <p style={{ textIndent: '2.5em' }}>{`- ${formSchema.content}`}</p>
                //     <br />
                //     <br />
                //   </>
                // ) : (
                // <p style={{ textIndent: '2.5em' }}>{formSchema.content}</p>
                <Message
                  type="warning"
                  description={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: formSchema.content,
                      }}
                    ></div>
                  }
                  style={{ textIndent: '2em' }}
                />
              )

              // ))
            }

            {formSchema.status?.statusCode == '170' && (
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <label>ความเห็นของศูนย์สัญญา : </label>
                <Message
                  type="warning"
                  description={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: formSchema.contractCenterSendbackMsg || '- ไม่ระบุ -',
                      }}
                    ></div>
                  }
                  style={{ textIndent: '2em' }}
                />
              </div>
            )}

            {formSchema.datetime && (
              <p style={{ paddingTop: 10 }}>
                <label style={{ marginRight: 20, marginTop: 20 }}>
                  {formSchema.datetime.dateLabel} <b>{formSchema.datetime.dateValue}</b>
                </label>
                <label>
                  {formSchema.datetime.timeLabel} <b>{formSchema.datetime.timeValue}</b>
                </label>
              </p>
            )}

            {formSchema.status && (
              <p>
                {formSchema.status.statusLabel} <b>{formSchema.status.statusValue}</b>
              </p>
            )}
          </div>
        ) : (
          <div>
            <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
            <Graph height={9} />
            <Graph height={9} />
            <Graph height={9} />
            <Graph height={9} />
            <Graph height={9} />

            <p>
              <label style={{ marginRight: 20, marginTop: 20 }}>
                วันที่ : <b>- ไม่ได้ระบุ -</b>
              </label>
              <label>
                เวลา : <b>- ไม่ได้ระบุ -</b>
              </label>
            </p>
            <p>
              สถานะ : <b>- ไม่ได้ระบุ -</b>
            </p>
          </div>
        )}
      </Panel>
      <br />
    </>
  )
}
